export default "__VITE_ASSET__ff02ZlcI__"